import React, { Component } from 'react'
import { Divider } from '@mui/material'

export class JsonFormDivider extends Component {
    render() {
        return <Divider sx={{ margin: '10px 0' }} />
    }
}

export default JsonFormDivider
